// location.js — the employee's current working location (sticky per kiosk
// until switched). Mirrors device.js/storage.js's localStorage pattern.
const LOCATION_KEY = "current_location";

export function getCurrentLocation() {
  try {
    const loc = JSON.parse(localStorage.getItem(LOCATION_KEY));
    if (loc?.id) return loc;
  } catch {}
  return null;
}

export function setCurrentLocation(location) {
  if (!location) {
    localStorage.removeItem(LOCATION_KEY);
    return;
  }
  localStorage.setItem(LOCATION_KEY, JSON.stringify({ id: location.id, name: location.name }));
}
